/// <reference path="../../_ext/editors/EditorDialogBase.ts" />

namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SequenceDetailsDialog extends _Ext.EditorDialogBase<SequenceDetailsRow> {
        protected getFormKey() { return SequenceDetailsForm.formKey; }
        protected getIdProperty() { return SequenceDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return SequenceDetailsRow.localTextPrefix; }
        protected getService() { return SequenceDetailsService.baseUrl; }
        protected getDeletePermission() { return SequenceDetailsRow.deletePermission; }
        protected getInsertPermission() { return SequenceDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SequenceDetailsRow.updatePermission; }

        protected form = new SequenceDetailsForm(this.idPrefix);

    }
}